import type { SupportAttachmentType } from "@repo/shared/types";
import { LifeBuoy } from "lucide-react";
import type { SupportOpenWithAttachmentDetail } from "@/components/sidebar/support-panel";
import { Button } from "@/components/ui/button";

type Props = {
  entityType: SupportAttachmentType;
  entityId: string;
  displayName: string;
  label?: string;
  variant?: "ghost" | "outline" | "default";
  size?: "sm" | "icon";
};

/**
 * "Report an issue with this …" button placed on the host page (chat panel,
 * flow-instance page). Opens the Support sidebar with the entity pre-staged
 * as a checked attachment.
 */
export function SupportButton({
  entityType,
  entityId,
  displayName,
  label = "Report issue",
  variant = "ghost",
  size = "sm",
}: Props) {
  const onClick = () => {
    const detail: SupportOpenWithAttachmentDetail = { entityType, entityId, displayName };
    window.dispatchEvent(new CustomEvent("support:open-with-attachment", { detail }));
  };
  // The icon size drops the label, so it is the one that needs the tooltip —
  // at any other size the label is right there and a tooltip would repeat it.
  const shared = { type: "button" as const, variant, onClick, className: "gap-1" };
  return size === "icon" ? (
    <Button {...shared} size="icon" tooltip={label}>
      <LifeBuoy className="h-4 w-4" />
    </Button>
  ) : (
    <Button {...shared} size={size}>
      <span className="text-xs">{label}</span>
    </Button>
  );
}
